import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getInventorySummaryReport(page, limit, startAt, filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getInventorySummaryReport`;
        return axios.post(url, {
            page,
            limit,
            startAt,
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    getInventoryComplianceReport(filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getInventoryComplianceReport`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    getInventoryScanProgressReport(filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getInventoryScanProgressReport`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    getAssetsWithTruckersReport(filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getAssetsWithTruckersReport`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    },

    getUserInventoryScansReport(filterBy, view, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/getUserInventoryScansReport`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy)
        });
    }
}